import {FC} from "react";
import {Img, Wrapper} from "./common";
import icon from "assets/images/icons/lock.svg";
import styled from "styled-components";

const WrapperStyled = styled(Wrapper)`
	background: #525252;

	&.dark {
		background: #202020;
	}
`;

const ImgStyled = styled(Img)`
	width: 50%;
	height: 50%;
`;

interface ILockedBadge {
	height?: string;
	width?: string;
	className?: string;
}

export const LockedBadge: FC<ILockedBadge> = ({height, width, className}) => {
	return (
		<WrapperStyled $width={width} $height={height} className={className}>
			<ImgStyled src={icon} alt="" />
		</WrapperStyled>
	);
};
